@if (isExpiredTokenPage === 2) {
<div class="alert alert-danger">
  <span class="alert-icon"><cx-icon class="fas fa-exclamation-circle" [type]="iconTypes.ERROR"></cx-icon></span
  ><span>{{ 'resetPassword.expiredMessage' | cxTranslate }}</span>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <cx-icon class="cx-icon fas fa-times"></cx-icon>
  </button>
</div>
<div class="form-forgot-password-wrapper">
  <div class="form-forgot">
    <a [routerLink]="['/login/forgot-password']">{{ 'resetPassword.resetButton' | cxTranslate }}</a>
  </div>
</div>
} @if (isExpiredTokenPage === 1) {
<div [ngClass]="isSuccess ? 'd-none' : 'reset-password-container'">
  <cx-global-message class="reset-global-message">
    <div class="global-message-wrapper"></div>
  </cx-global-message>
  @if (err) {
  <div class="reset-password-error alert alert-danger alert-dismissible fade show" role="alert">
    <span class="alert-icon"><cx-icon class="fas fa-exclamation-circle" [type]="iconTypes.ERROR"></cx-icon></span>
    <mat-label> {{ 'resetPassword.expiredMessage' | cxTranslate }} </mat-label>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="close($event)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  }
  <form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
    <mat-form-field appearance="outline" class="mt-3" [hideRequiredMarker]="true">
      <mat-label>{{ 'resetPassword.newPasswordLabel' | cxTranslate }}</mat-label>
      <input
        matInput
        type="password"
        placeholder="{{ 'resetPassword.newPasswordLabel' | cxTranslate }}"
        formControlName="newPassword"
      />
      @if (resetPasswordForm.hasError('required', 'newPassword')) {
      <mat-error>
        {{ 'resetPassword.errorMessages.newRequired' | cxTranslate }}
      </mat-error>
      } @if (resetPasswordForm.hasError('pattern', 'newPassword')) {
      <mat-error>
        {{ 'resetPassword.errorMessages.passPattern' | cxTranslate }}
      </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" [hideRequiredMarker]="true">
      <mat-label>{{ 'resetPassword.confirmPasswordLabel' | cxTranslate }}</mat-label>
      <input
        matInput
        type="password"
        placeholder="{{ 'resetPassword.confirmPasswordLabel' | cxTranslate }}"
        formControlName="confirmPassword"
      />
      @if (resetPasswordForm.hasError('required', 'confirmPassword')) {
      <mat-error>
        {{ 'resetPassword.errorMessages.confirmRequired' | cxTranslate }}
      </mat-error>
      } @if (resetPasswordForm.hasError('mustMatch', 'confirmPassword')) {
      <mat-error>
        {{ 'resetPassword.errorMessages.passMustMatch' | cxTranslate }}
      </mat-error>
      }
    </mat-form-field>
    <div
      class="change-password-guide"
      [class.sv]="(activeLanguage$ | async) === 'sv' && resetPasswordForm.hasError('mustMatch', 'confirmPassword')"
    >
      <h5>{{ 'changePasswordForm.guidelines.heading' | cxTranslate }}</h5>
      <div class="password-guidelines" [innerHTML]="'changePasswordForm.guidelines.guide' | cxTranslate"></div>
    </div>
    <div class="reset-password-button">
      <button mat-button class="btn-primary">{{ 'resetPassword.resetButton' | cxTranslate }}</button>
    </div>
  </form>
</div>
<div [ngClass]="isSuccess ? 'reset-password-success' : 'd-none'">
  <h1>{{ 'resetPassword.successHeading' | cxTranslate }}</h1>
  <p>{{ 'resetPassword.successMessage' | cxTranslate }}</p>
  <div class="reset-password-success-button">
    <button mat-button class="btn-primary" (click)="goToLogin()">
      {{ 'resetPassword.successButton' | cxTranslate }}
    </button>
  </div>
</div>
}
